<template>
  <div class='AdmLogin'>
    <div class="cont-img">
      <div class="text">
        Sistemas Web facilitando a sua vida
      </div>
    </div>
    <div class="cont-form">
      <div class="form">
        <input-login-adm @returnValue="newValue => email = newValue"/>
        <input-login-adm icon="passIcon" type="password" @returnValue="newValue => senha = newValue"/>
        <vue-spinner size="30" color="#35adfb" v-if="load"/>
        <btn-login-adm v-if="!load" @click="login"/>
        <div class="erro">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import inputLoginAdm from './inputLoginAdm'
import BtnLoginAdm from './BtnLoginAdm'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'AdmLogin',
  components: { inputLoginAdm, BtnLoginAdm, VueSpinner },
  data () {
    return {
      load: false,
      email: '',
      senha: '',
      message: ''
    }
  },
  methods: {
    ...mapActions(['GetLoginAdm']),
    login () {
      this.message = ''
      this.load = true
      this.GetLoginAdm({ email: this.email, senha: this.senha })
        .then(res => {
          if (!res.status) {
            this.message = res.message
            this.load = false
          }
          if (res.status) {
            this.$router.push('/enb/workspace')
            this.load = false
          }
        })
    }
  }
}
</script>

<style scoped>
.AdmLogin {
  width: 100%;
  height: 100%;
  display: flex;
}
.cont-img {
  width: 75%;
  height: 100%;
  background-color: #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cont-form {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form {
  width: 100%;
}
.text {
  font-family: Poppins;
  width: 50%;
  padding-bottom: 5%;
  font-weight: 600;
  font-size: 50px;
  line-height: 50px;
  margin: auto;
  color: #286faf;
}
.erro {
  margin-top: 2%;
  height: 16px;
}
</style>
